import { OvertaxStorage } from '@/utils/overtax'

export const isMedistream = () => {
  return OvertaxStorage.get('from') === 'medistream'
}
